import SecondarySaleEndStockActions from "../actions/secondarySale_endStock_Action";

const SecondarySaleEndStockReducer = (
    state = { is_ED_Loading: false, is_SS_Loading: false, is_SS_ED_Loading: false },
    action
) => {
    switch (action.type) {
        case SecondarySaleEndStockActions.SECONDARYSALE_ENDSTOCK_REQUEST:
            return {
                ...state,
                is_SS_ED_Loading: true
            };
        case SecondarySaleEndStockActions.SECONDARYSALE_ENDSTOCK_SUCCESSFUL:
            return {
                ...state,
                is_SS_ED_Loading: false,
                secondarySaleEndStock: action.data.data
            };
        case SecondarySaleEndStockActions.SECONDARYSALE_ENDSTOCK_FAILED:
            return {
                ...state,
                errorMessage: {},
                is_SS_ED_Loading: false
            };

        //only end stock
        case SecondarySaleEndStockActions.ENDSTOCK_REQUEST:
            return {
                ...state,
                is_ED_Loading: true
            };
        case SecondarySaleEndStockActions.ENDSTOCK_SUCCESSFUL:
            return {
                ...state,
                is_ED_Loading: false,
                EndStock: action.data.data
            };
        case SecondarySaleEndStockActions.ENDSTOCK_FAILED:
            return {
                ...state,
                errorMessage: {},
                is_ED_Loading: false
            };

        //only secondary sale
        case SecondarySaleEndStockActions.SECONDARYSALE_REQUEST:
            return {
                ...state,
                is_SS_Loading: true
            };
        case SecondarySaleEndStockActions.SECONDARYSALE_SUCCESSFUL:
            return {
                ...state,
                is_SS_Loading: false,
                SecondarySale: action.data.data
            };
        case SecondarySaleEndStockActions.SECONDARYSALE_FAILED:
            return {
                ...state,
                errorMessage: {},
                is_SS_Loading: false
            };

        default:
            return {
                ...state
            };
        //   break;

    }
};

export default SecondarySaleEndStockReducer;
